import { DataGridTypes } from "devextreme-react/data-grid";
import { Button } from "devextreme-react/button";

import { Constants } from "@/shared/constants";
import { FiscalPeriod } from "@/shared/models/ProductionDeterminantListing";

const DataGridCustomizeCell = (
  cellData: DataGridTypes.ColumnCellTemplateData,
  fiscalPeriod: FiscalPeriod,
  handleEditDetail: (
    e: DataGridTypes.ColumnCellTemplateData,
    fiscalPeriod: FiscalPeriod,
  ) => void,
  handleGetCurrentRate: (
    e: DataGridTypes.ColumnCellTemplateData,
    fiscalPeriod: FiscalPeriod,
  ) => void,
) => {
  if (cellData.row.data.Determinant === Constants.PowerBillingPeriod) {
    return <div> {cellData.value}</div>;
  } else if (cellData.value === Constants.GetCurrentRate) {
    return (
      <Button
        type="default"
        onClick={() => handleGetCurrentRate(cellData, fiscalPeriod)}
        className="in-grid-button"
      >
        {Constants.GetCurrentRate}
      </Button>
    );
  } else {
    return (
      <div
        className="cursor-point"
        onClick={() => handleEditDetail(cellData, fiscalPeriod)}
      >
        {cellData.value}
      </div>
    );
  }
};

export default DataGridCustomizeCell;
